module.exports = __webpack_public_path__ + "img/59.64a38152.png";